import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth/auth.service';
import {LoadingService} from '../../../services/loadingService/loading.service';
import {Router} from '@angular/router';
import {Route} from '../../../enum/route';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-hvb-header',
    templateUrl: './hvb-header.component.html',
    styleUrls: ['./hvb-header.component.scss'],
    standalone: false
})
export class HvbHeaderComponent implements OnInit{

  lang: string = '';
  languages = ['en', 'de', 'it'];

  constructor(public readonly authService: AuthService,
              private readonly loadingService: LoadingService,
              public readonly router: Router,
              private readonly translateService: TranslateService) {
  }

  login() {
    this.loadingService.startLoading();
    this.authService.login();
  }

  navigateToAbout() {
    this.router.navigateByUrl(Route.ABOUT);
  }

  navigateToStart() {
    this.router.navigateByUrl('');
  }

  navigateToContact() {
    this.router.navigateByUrl(Route.CONTACT);
  }

  navigateToDownloads() {
    this.router.navigateByUrl(Route.DOWNLOADS);
  }

  navigateToEvents() {
    this.router.navigateByUrl(Route.EVENT);
  }

  changeLanguage() {
    localStorage.setItem('lang', this.lang);
    this.translateService.use(this.lang);
    window.location.reload();
  }

  ngOnInit() {
    this.lang = localStorage.getItem('lang') || navigator.language.slice(0,2);
  }


}
